export const DEFAULT_QUERIES_OPTIONS = {
    shallow: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
}

export const Persisters = {
    LowCardinality: 'LowCardinality',
    MediumCardinality: 'MediumCardinality',
    HighCardinality: 'HighCardinality',
} as const

export type PersisterCardinality = keyof typeof Persisters
